import {GalleryImageItem} from '@/components/commons/gallery-image-item/GalleryImageItem'
import styled, {css} from 'styled-components'

export const StyledActivityTitle = styled.p`
    ${({theme: {palette, typography}}) => css`
        font-weight: 500;
        color: ${palette.neutral[900]};
        ${typography.textMd}
    `}
`

export const StyledActivityImage = styled(GalleryImageItem)`
    ${() => css`
        width: 64px;
        height: 64px;
    `}
`
